import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { StateService } from "../../providers/state.service";
import { PoolModel } from "../models/pool";
import { CommonService } from "../services/common.service";
import { ResearchReportModel } from "./../models/research";
@Component({
  templateUrl: "dashboard.component.html",
  styleUrls: ["dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  pools: PoolModel[];
  poolIdActive: number;
  poolActive: PoolModel = null;
  loading: boolean = false;
  activeNav = {};
  subs: Subscription[] = [];

  public researchList: ResearchReportModel[] = [];

  constructor(
    private readonly commonService: CommonService,
    private readonly stateService: StateService
  ) {}

  ngOnInit(): void {
    this.activeNav = this.stateService.activeNav$.getValue();
    const subscription = this.stateService.activeNav$.subscribe(
      (activeNav: any) => {
        this.commonService.checkActiveRoute(activeNav);
        if (activeNav) {
          this.activeNav = activeNav;
          (async () => {
            await this.getData(activeNav);
          })();
        }
      }
    );

    this.subs.push(subscription);
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  async getData(activeNav: any) {
    this.loading = true;
    const pools = await this.commonService.getPoolsV2(true, activeNav.id);
    if (pools.length) {
      this.poolActive = this.commonService.getPoolActive();
    }
    this.pools = pools;
    this.loading = false;
  }

  async handlePoolClick(pool: PoolModel) {
    this.commonService.setPoolActive(pool);
    this.poolActive = pool;
  }

  changeLoading(status: boolean) {
    this.loading = status;
  }
}
